// Re-export the shared ProductDashboard component for seller
import ProductDashboard from "../Admin/ProductDashboard";

export default function SellerProductDashboard() {
    return <ProductDashboard role="seller" />;
}

